<template>
  <section class="team-section" aria-labelledby="team-title">
    <div class="team-inner">
      <h2 id="team-title" class="team-title">Chi c'è dietro Sportemocracy</h2>
      <div class="team-grid">
        <article class="team-card" v-for="founder in founders" :key="founder.name">
          <div class="card-photo">
            <img :src="require('@/assets/' + founder.image)" :alt="'Foto di ' + founder.name" />
          </div>
          <div class="card-info">
            <p class="founder-name">{{ founder.name }}</p>
            <p class="founder-role">{{ founder.role }}</p>
            <p class="founder-description">{{ founder.bio }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamSection',
  data() {
    return {
      founders: [
        {
          name: 'Greta Rossetto',
          role: 'Co-founder & CTO',
          image: 'greta_quadrato.jpg',
          bio: 'Laureata in Software Engineering & IT Management, lavoro come Product Manager nel settore Energy. Dalla giovane età vivo lo sport dall\'interno: oltre dieci anni di basket, di cui alcuni da professionista e una base atletica costruita su tanti sport diversi. Oggi mi identifico come tennista alle prime armi. In Sportemocracy porto quindi sia il mio bagaglio tecnico che quello sportivo. Credo che la tecnologia possa trasformare il modo in cui ci si allena e il mio obiettivo è fare in modo che strumenti fino ad oggi riservati a pochi, diventino accessibili a chiunque voglia migliorarsi.'
        },
        {
          name: 'Riccardo Vantini',
          role: 'Co-founder & Sport Leader',
          image: 'riki_quadrato.jpeg',
          bio: 'Laureato in Scienze Motorie e in Scienze e Tecniche Psicologiche; da due anni lavoro con la nazionale assoluta femminile di bob austriaca e una parte della nazionale giovanile austriaca di atletica leggera. Amo lo sport in qualsiasi sua forma: nel mio percorso ho avuto la possibilità di lavorare con olimpionici, atleti delle nazionali, giovani in fase di crescita, bambini e sportivi amatoriali, confrontandomi ogni volta con esigenze, contesti e obiettivi molto diversi tra loro. Il mio sogno è quello di dare la possibilità a tutte e tutti di poter accedere ad una preparazione fisica degna di un centro di preparazione olimpica.'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.team-section {
  background-color: $primary;
  color: $white;
}

.team-inner {
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.team-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
}

.team-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.team-card {
  display: flex;
  flex-direction: column;
  border: 1px solid $white;
  border-radius: 25px;
  overflow: hidden;
}

.card-photo {
  aspect-ratio: 1 / 1;
  background-color: $primary-light;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
  }
}

.card-info {
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.founder-name {
  margin: 0;
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 1.2;
}

.founder-role {
  margin: 8px 0 0;
  font-size: 1.875rem;
  font-weight: 400;
  line-height: 1.2;
}

.founder-description {
  margin: 32px 0 0;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.6;
}

@media (min-width: 768px) {
  .team-inner {
    padding: 64px 40px;
    gap: 48px;
  }

  .team-title {
    font-size: 2.2rem;
  }

  .card-info {
    padding: 32px;
  }
}


/* Landscape mobile S: 568–667px (SE, 6/7/8) */
@media (max-width: 667px) and (orientation: landscape) {
  .team-grid {
    max-width: 520px;
    margin: 0 auto;
    gap: 32px;
  }
}

/* Landscape mobile M/L: 668–1023px (X, 12, 13, 14, Plus, Pro Max) */
@media (min-width: 668px) and (max-width: 1023px) and (orientation: landscape) {
  .team-grid {
    max-width: 700px;
    margin: 0 auto;
    gap: 32px;
  }
}

/* Tablet landscape: iPad Mini, Air, Pro 11" (1024–1365px) */
@media (min-width: 1024px) and (max-width: 1365px) and (orientation: landscape) {
  .team-inner {
    padding: 80px 40px;
  }

  .team-title {
    font-size: 2.4rem;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 48px;
  }

  .card-info {
    padding: 40px;
  }
}

/* Desktop landscape: iPad Pro 12.9" e desktop (≥1366px) */
@media (min-width: 1366px) and (orientation: landscape) {
  .team-inner {
    padding: 80px 120px;
  }

  .team-title {
    font-size: 2.4rem;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 64px;
    padding: 0 120px;
  }

  .card-info {
    padding: 40px;
  }
}
</style>
